import setting from './setting';
export default {
    getListById: ($axios,data)=>{
        return $axios.get(`${setting.http.base_url}/supervisor/lista/${data}`, {headers:setting.http.headers()});
    },

}